import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ArticlesPage from "@/pages/ArticlesPage";
import ArticleFormPage from "@/pages/ArticleFormPage";
import UsersPage from "@/pages/UsersPage";
import CategoriesPage from "@/pages/CategoriesPage";
import ValidationPage from "@/pages/ValidationPage";
import BackupPage from "@/pages/BackupPage";
import ImportPage from "@/pages/ImportPage";
import DownloadsPage from "@/pages/DownloadsPage";
import MediaPage from "@/pages/MediaPage";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const AuthContext = React.createContext();

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      checkAuth();
    } else {
      setLoading(false);
    }
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`);
      setUser(response.data);
    } catch (error) {
      localStorage.removeItem("token");
      delete axios.defaults.headers.common["Authorization"];
    } finally {
      setLoading(false);
    }
  };

  const login = (token, userData) => {
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["Authorization"];
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/" />} />
            <Route path="/" element={user ? <DashboardPage /> : <Navigate to="/login" />} />
            <Route path="/articles" element={user ? <ArticlesPage /> : <Navigate to="/login" />} />
            <Route path="/articles/new" element={user?.role === "admin" ? <ArticleFormPage /> : <Navigate to="/" />} />
            <Route path="/articles/edit/:id" element={user?.role === "admin" ? <ArticleFormPage /> : <Navigate to="/" />} />
            <Route path="/users" element={user?.role === "admin" ? <UsersPage /> : <Navigate to="/" />} />
            <Route path="/categories" element={user?.role === "admin" ? <CategoriesPage /> : <Navigate to="/" />} />
            <Route path="/validation" element={user ? <ValidationPage /> : <Navigate to="/login" />} />
            <Route path="/backup" element={user?.role === "admin" ? <BackupPage /> : <Navigate to="/" />} />
            <Route path="/import" element={user?.role === "admin" ? <ImportPage /> : <Navigate to="/" />} />
            <Route path="/downloads" element={user ? <DownloadsPage /> : <Navigate to="/login" />} />
            <Route path="/media" element={user?.role === "admin" ? <MediaPage /> : <Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthContext.Provider>
  );
}

export default App;
